/// <reference path="../../ng-services/chat.service.ts"/>

import { ChatConversationMessage, Meeting } from '../../models/chat';
import { ChatConversationService } from '../../ng-services/chat-conversation.service';
import { ChatCurrentlyTypingService } from '../../ng-services/chat-currently-typing.service';
import { ChatMessageInputStore } from '../../ng-services/chat-message-input.store';
import { ChatMessageSenderService } from '../../ng-services/chat-message-sender.service';
import { EmojiService } from '../../ng-services/emoji.service';

(function () {
    const PUBLIC_CHAT_ID = 0;

    class ChatMessageInputComponent {
        static $inject = [
            'ChatMessageInputStore',
            'ChatMessageSenderService',
            'ChatConversationService',
            'ChatCurrentlyTypingService',
            'EmojiService',
            '$element',
        ];

        constructor(
            private chatMessageInputStore: ChatMessageInputStore,
            private messageSender: ChatMessageSenderService,
            private chatConversationService: ChatConversationService, // todo: remove? - move quote & edit to chatMessageInputStore
            private chatCurrentlyTypingService: ChatCurrentlyTypingService,
            private emojiService: EmojiService,
            private $element: ng.IAugmentedJQuery
        ) {}

        public conversation!: Meeting;
        public quotedMessage?: ChatConversationMessage;
        public message!: string;
        public editedMessage?: ChatConversationMessage;

        private subscribes!: Rx.IDisposable[];

        $onInit() {
            this.subscribes = [
                this.chatMessageInputStore.getMessageInputState$(this.conversation.id).subscribe((s) => {
                    this.message = s.content;
                    this.quotedMessage = s.quoted_message;
                    this.editedMessage = s.editedMessage;
                }),
                this.chatConversationService.quotedMessage$.subscribe((m) => {
                    this.chatMessageInputStore.dispatchUpdateInputState(this.conversation.id, {
                        quoted_message: m,
                    });
                }),
                this.chatConversationService.editMessage$.subscribe((m) => {
                    this.chatMessageInputStore.dispatchSetInputState(this.conversation.id, {
                        editedMessage: m,
                        content: m.content,
                        quoted_message: m.quoted_message,
                    });
                }),
                this.chatMessageInputStore
                    .getMessageInputState$(this.conversation.id)
                    // the 1st emit occurs when user switches chat - we ignore that
                    .skip(1)
                    .throttle(1000)
                    .subscribe((m) => {
                        // for public chats we should not emit this event, as there might be 100s of people typing
                        // and we are not even able to have a full list of participants
                        if (this.conversation.id == PUBLIC_CHAT_ID) return;
                        this.chatCurrentlyTypingService.tellOthersIAmTyping(this.conversation.id);
                    }),
            ];
        }

        $onDestroy() {
            this.subscribes.forEach((d) => d.dispose());
        }

        get isMobile() {
            // naive check for mobile agent
            return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        }

        keydown(event: KeyboardEvent) {
            const KEY_ARROW_UP = 38;
            const KEY_ESC = 27;

            // cancel edit or quote
            if (event.keyCode === KEY_ESC) {
                this.quotedMessage && this.cancelQuote();
                this.editedMessage && this.cancelEdit();
            }

            // editing last message with ctrl + ↑
            if (event.keyCode === KEY_ARROW_UP && event.ctrlKey === true && event.shiftKey === false) {
                this.chatConversationService.editLastMessage(this.conversation);
            }
        }

        submit() {
            // sending message with Enter
            this.sendMessage();
        }

        onMessageChanged(message: string) {
            this.message = message;
            this.chatMessageInputStore.dispatchUpdateInputState(this.conversation.id, {
                content: this.message,
                quoted_message: this.quotedMessage,
                editedMessage: this.editedMessage,
            });
        }

        sendMessage() {
            this.messageSender.publish(this.conversation.id);
            this.reset();
        }

        cancelQuote() {
            this.reset();
        }

        cancelEdit() {
            this.reset();
        }

        protected reset() {
            this.chatMessageInputStore.dispatchUpdateInputState(this.conversation.id, {
                content: '',
                quoted_message: undefined,
                editedMessage: undefined,
                uploads: [],
            });
        }
    }

    angular.module('tradersyard').component('tyChatMessageInput', {
        // language=HTML
        template: `<div ty-chat-upload-paste>
    <div class="chat_message_input" is-uib>

        <div class="chat_message_input__container">
            <div class="chat_message_input__header" ng-if="$ctrl.editedMessage">
                <i class="fa fa-edit"></i> Editing
            </div>

            <div class="chat_message_input__header" ng-if="$ctrl.quotedMessage">
                <i class="fa fa-quote-left"></i> Quoting
            </div>

            <div
                ng-if="$ctrl.quotedMessage"
                class="chat_message_input__quoted_message"
            >
                <ty-chat-quoted-message quoted-message="$ctrl.quotedMessage"/>
                <label ng-click="$ctrl.cancelQuote();" title="remove quote"
                       class="chat_message_input__quoted_message__cancel"><i class="fa fa-times"></i></label>
            </div>
            <ty-simplemde
                placeholder="Type your message..."
                value="$ctrl.message"
                on-change="$ctrl.onMessageChanged($value)"
                on-keydown="$ctrl.keydown($event)"
                on-submit="$ctrl.submit($value)"
                ng-if="!$ctrl.isMobile"
            />
            <ty-chat-message-input-textarea
                placeholder="Type your message..."
                value="$ctrl.message"
                on-change="$ctrl.onMessageChanged($value)"
                on-keydown="$ctrl.keydown($event)"
                on-submit="$ctrl.submit($value)"
                ng-if="$ctrl.isMobile"
            ></ty-chat-message-input-textarea>
            <ty-chat-message-upload conversation="$ctrl.conversation"/>
            <div ng-if="$ctrl.editedMessage" class="btn-group-xs chat_message_input__edit_toolbar">
                <label class="btn btn-default" ng-click="$ctrl.cancelEdit();">Cancel</label>
                <label class="btn btn-success" ng-click="$ctrl.sendMessage();"><i class="fas fa-paper-plane"></i> Save
                    changes</label>
            </div>
        </div>
        <ty-message-input-toolbar conversation="$ctrl.conversation"/>
    </div>
</div>
`,
        controller: ChatMessageInputComponent,
        bindings: {
            conversation: '<',
        },
    });
})();
